/* eslint-disable camelcase */
import { Vue, Component } from 'vue-property-decorator'
import { ModalUtils } from '@/shared/util/modal-utils'
import { ConfirmationModalCheckableResponse } from '@/shared/models/common.models'

@Component
export class ModalMixin extends Vue {
    $_showInfoModal(message: string): void {
        ModalUtils.showInfoModal(message)
    }
    $_showWarningModal(message: string): void {
        ModalUtils.showWarningModal(message)
    }
    $_showSuccessModal(message: string = this.$tc('component.modalShowSuccess.title')): void {
        ModalUtils.showSuccessModal(message)
    }
    $_showErrorModal(message: string = this.$tc('component.modalError.title')): void {
        ModalUtils.showErrorModal(message)
    }

    $_showErrorModalFromErrorResponse(error: any, alternativeMessage?: string): void {
        ModalUtils.showErrorModalFromErrorResponse(error, alternativeMessage)
    }

    $_showConfirmationModal(
        question: string = '',
        okTitle?: string,
        cancelTitle?: string,
        qaId?: number,
        cancelOnHide?: boolean
    ): Promise<boolean> {
        return ModalUtils.showConfirmationModal(question, okTitle, cancelTitle, qaId, cancelOnHide)
    }

    $_showConfirmationModalCheckable(
        params: {
            question?: string,
            okTitle?: string,
            cancelTitle?: string,
            qaId?: number,
            cancelOnHide?: boolean,
            checkable?: boolean,
            dontShowAgainCheckableText?: string
        }): Promise<ConfirmationModalCheckableResponse> {
        return ModalUtils.showConfirmationModalCheckable(params)
    }
}
